import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ILessonListItem } from '@lb/api/mylb/interfaces';
import { NotificationBaseComponent } from './notification-base/notification-base.component';
import { TzDatePipe } from '@lb/pipes/timezone-aware-date.pipe';

/**
 * Learner notification: a mid-semester lesson is complete but its survey has not been submitted.
 * `data` is the lesson hydrated by Notification.Api from Lesson.Api; EntityID is the LessonID.
 *
 * The backend sweep auto-dismisses this notification once the survey is submitted, so the action
 * simply routes the learner to the lesson detail page where the survey is completed.
 */
@Component({
	standalone: true,
	imports: [CommonModule, NotificationBaseComponent, TzDatePipe],
	selector: 'lb-notification-mid-semester-survey-incomplete',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			Please complete your mid-semester survey for the lesson on
			<b>{{ lesson()?.lessonDate | tzDate: 'MMM d' }}</b
			>.
		</div>
		<div activity-action>
			@if (lesson()) {
				<button type="button" md-button (click)="completeSurvey()">Complete Survey</button>
			}
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationMidSemesterSurveyIncompleteComponent extends NotificationBaseComponent {
	private readonly _router = inject(Router);

	lesson = computed(() => this.notification().data as ILessonListItem);

	completeSurvey(): void {
		const lesson = this.lesson();
		if (!lesson) {
			return;
		}
		this._router.navigate(['/enrollments', lesson.enrollmentID, 'lessons', lesson.lessonID]);
	}
}
